export const productLanes = [
  {
    id: 'donation-access',
    name: 'Donation / Access Certificate',
    forWhom: 'NGOs, creators, foundations, education projects, and public-purpose campaigns.',
    requiredDocument: 'Campaign terms, use-of-funds statement, donor or beneficiary policy, and tax receipt authority if applicable.',
    tangibleOutput: 'Contribution certificates, donor records, access credentials, and audit-ready campaign records.',
    bestUse: 'Contribution certificates, donor records, public-purpose campaigns, access rights, and book-publication receipts.',
    requiredFiles: ['Issuer profile', 'Campaign terms', 'Use-of-funds statement', 'Beneficiary or donor policy', 'Tax receipt authority, if applicable'],
    riskLevel: 'Low to Medium',
    humanReviewRequired: true,
  },
  {
    id: 'secured-note',
    name: 'Secured Note Certificate',
    forWhom: 'Private credit, issuer financing, secured notes, and repayment-based programs.',
    requiredDocument: 'Loan or note agreement, collateral schedule, repayment terms, issuer KYB, and transfer restriction policy.',
    tangibleOutput: 'Controlled debt participation certificates with repayment records, beneficiary ledger, and transfer controls.',
    bestUse: 'Debt participation certificates linked to legal note documents, collateral terms, repayment rules, and transfer restrictions.',
    requiredFiles: ['Loan or note agreement', 'Issuer KYB', 'Collateral schedule', 'Repayment terms', 'Transfer restriction policy'],
    riskLevel: 'High',
    humanReviewRequired: true,
  },
  {
    id: 'warrant-inventory',
    name: 'Warehouse / Warrant Certificate',
    forWhom: 'Commodity operators, inventory owners, warehouse programs, warranteras, and collateral managers.',
    requiredDocument: 'Warehouse receipt, warrant, asset evidence, storage agreement, insurance document if applicable, and release procedure.',
    tangibleOutput: 'Inventory-linked digital certificates with evidence files, controlled transfers, and audit records.',
    bestUse: 'Inventory-backed certificate workflows supported by asset evidence, warehouse records, producer files, warrant files, or collateral files.',
    requiredFiles: ['Warehouse receipt or warrant', 'Asset evidence', 'Storage agreement', 'Insurance document, if applicable', 'Collateral release procedure'],
    riskLevel: 'High',
    humanReviewRequired: true,
  },
  {
    id: 'fiduciary-participation',
    name: 'Fiduciary / Trust Participation',
    forWhom: 'Trusts, fideicomisos, fiduciary structures, SPVs, and beneficiary-administered rights.',
    requiredDocument: 'Trust or fiduciary document, responsible fiduciary information, beneficiary rules, asset schedule, and jurisdiction memo.',
    tangibleOutput: 'Beneficiary-ledger infrastructure and controlled participation certificate records.',
    bestUse: 'Beneficiary-ledger infrastructure for trust, fideicomiso, fiduciary participation, or SPV-administered rights.',
    requiredFiles: ['Trust or fiduciary document', 'Responsible fiduciary information', 'Beneficiary rules', 'Asset schedule', 'Jurisdiction memo'],
    riskLevel: 'High',
    humanReviewRequired: true,
  },
  {
    id: 'asset-registry',
    name: 'Asset Registry / Beneficiary Ledger',
    forWhom: 'Issuers that need structured ownership, rights, or beneficiary records connected to wallets and audit files.',
    requiredDocument: 'Issuer profile, registry schema, beneficiary list, transfer policy, and audit export format.',
    tangibleOutput: 'A reconciled off-chain/on-chain registry with certificate records, wallet references, and reporting exports.',
    bestUse: 'Off-chain legal records reconciled with on-chain digital certificates, wallet records, and accounting exports.',
    requiredFiles: ['Issuer profile', 'Registry schema', 'Beneficiary list', 'Transfer policy', 'Audit export format'],
    riskLevel: 'Medium',
    humanReviewRequired: true,
  },
];
